import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '部署在',
    type: 'MIDINS_DEPLOYED_IN',
}
